/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_TitleInputs */

const en_colleague_title = /** @type {(inputs: Colleague_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colleague tickets`)
};

const ja_colleague_title = /** @type {(inputs: Colleague_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同僚のチケット`)
};

const fr_colleague_title = /** @type {(inputs: Colleague_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets des collègues`)
};

const de_colleague_title = /** @type {(inputs: Colleague_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kollegen-Tickets`)
};

/**
* | output |
* | --- |
* | "Colleague tickets" |
*
* @param {Colleague_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_title = /** @type {((inputs?: Colleague_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_title(inputs)
	if (locale === "ja") return ja_colleague_title(inputs)
	if (locale === "fr") return fr_colleague_title(inputs)
	return de_colleague_title(inputs)
});